import styled from 'styled-components';
import { rem } from 'polished';
import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';

const NavPaginator = styled.nav`
  display: flex;
  justify-content: center;
`;

const WrapperPaginator = styled.ul`
  margin: 0;
  padding-left: 0;
`;

const ElementPaginator = styled.li`
  box-sizing: border-box;
  display: inline;
  margin: 0 ${rem('5px')};
  padding: 0;
  :before {
    content: none;
  }
`;

const LinkPaginator = styled.a`
  align-items: center;
  box-sizing: content-box;
  color: ${props => props.theme.colors.gray};
  display: inline-flex;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  height: ${rem('26px')};
  justify-content: center;
  min-width: ${rem('26px')};
  padding: ${rem('2px')};

  /* state selected */
  ${props =>
    props.selected &&
    `
    background-color: ${props.theme.colors.primary};
    color: ${props.theme.colors.light};
  `};
`;

const DotsPaginator = LinkPaginator.withComponent('span');

/**
 * Overwrite the arrows buttons style.
 * I define a constant used on two buttons.
 * These share the same style
 */
const buttons = `
  background: transparent;
  box-sizing: content-box;
  height: ${rem('30px')};
  padding: 0 ${rem('12px')};
  position: static;
  width: ${rem('6px')};
`;

const ArrowLeftPaginator = styled(ButtonArrowLeft)`
  ${buttons};
`;

const ArrowRightPaginator = styled(ButtonArrowRight)`
  ${buttons};
`;

export {
  NavPaginator,
  WrapperPaginator,
  ElementPaginator,
  LinkPaginator,
  DotsPaginator,
  ArrowLeftPaginator,
  ArrowRightPaginator
};
